@if (!(pending | async) && ((emailNotificationError | async) || (policyError | async))) {
  <div class="row lg-flex margin-30">
    <div class="column ten flex-min-0">
      <ds-error-message [errorList]="policyErrorList"></ds-error-message>
    </div>
  </div>
}

@if (
  !(policyError | async) &&
  !!(firstName | async) &&
  !!(lastName | async) &&
  !!(currentAddress | async) &&
  (policyList | async)?.length > 0
) {
  <layout-sidebar>
    <div class="main">
      <app-plchangerequest-form
        [currentAddress]="currentAddress | async"
        [firstName]="firstName | async"
        [lastName]="lastName | async"
        [policyList]="policyList | async"
        [propertyPolicies]="propertyPolicies | async"
        [agents]="agents$ | async"
        [addressInfo]="addressInfo$ | async"
        [driverLicense]="driverLicense$ | async"
        [vinInfo]="driverLicense$ | async"
        [drivers]="drivers$ | async"
        [risks]="risks$ | async"
        [years]="years$ | async"
        [newTemplate]="newTemplate"
        [isPartner]="isPartner$ | async"
        (changeRequest)="handleChangeRequest($event)"
        (handleCancel)="handleCloseEvent()"
      >
      </app-plchangerequest-form>
    </div>
    <aside class="main-aside"><links-agents-sidebar></links-agents-sidebar></aside>
  </layout-sidebar>
}
